import { SvgIconsModule } from "./svg-icons/svg-icons.module";
import { FullWidthTableDirective } from "./directives/full-width-table/full-width-table.directive";
import { CreatePlanComponent } from "./create-plan/create-plan.component";
import { RefreshPromptComponent } from "./refresh-prompt/refresh-prompt.component";
import { NgModule } from "@angular/core";
import { WfmTextboxComponent } from "./wfm-textbox/wfm-textbox.component";
import { WfmSelectComponent } from "./wfm-select/wfm-select.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { InputTextComponent } from "./input-text/input-text.component";
import { BreezeButtonComponent } from "./breeze-button/breeze-button.component";
import { IconNameDirective } from "./svg-icons/icon-name.directive";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";
import { PageTitleComponent } from "./page-title/page-title.component";
import { WfmModalComponent } from "./wfm-modal/wfm-modal.component";
import { CheckboxListComponent } from "./checkbox-list/checkbox-list.component";
import { CreatePlanComponentV2 } from "./create-plan-v2/create-plan-v2.component";
import { MultiSelectModule } from 'primeng/multiselect'
import { WeekPickerComponent } from './week-picker/week-picker.component';
import { NgbDatepickerModule, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { TaskProgressComponent } from './task-progress/task-progress.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { EspTableHeaderComponent } from "./esp-table-header/esp-table-header.component";
import { EspNoRowsOverlayComponent } from "./no-rows-overlay/no-rows-overlay.component";
import { GridItemActionComponent } from "./grid-item-action/grid-item-action.component";
import { InputFocusDirective } from './directives/auto-focus/auto-focus.directive';
import { ToastSingleAnnounceDirective } from './directives/toast-single-announce/toast-single-announce.directive';
import { DatepickerDayAriaLabelsDirective } from './directives/datepicker-day-aria-labels/datepicker-day-aria-labels.directive';
import { SideNavComponent } from "./side-nav/side-nav.component"
import { TooltipModule } from "primeng/tooltip";
import { TimePickerModule } from "@niceltd/sol/time-picker";
import { DateRangePickerModule } from "@niceltd/sol/date-range-picker";
import { OverlayModule } from "@angular/cdk/overlay";

import { LicenseManager } from "@ag-grid-enterprise/core";
import { MultiSelectFilterComponent } from './multi-select-filter/multi-select-filter.component';
import { MultiSelectFooterComponent } from './multi-select-footer/multi-select-footer.component';
import { LoadingRowsOverlayComponent } from './loading-rows-overlay/loading-rows-overlay.component';
import { ValidationNavigatorComponent } from './validation-navigator/validation-navigator.component';
import { MuGroupHeaderComponent } from './mu-group-header/mu-group-header.component';
import { ApiCredentialComponent } from './api-credential/api-credential.component';
import { WfmIcontextboxComponent } from './wfm-icontextbox/wfm-icontextbox.component';
import { MultiSelectItemComponent } from './multi-select-item/multi-select-item.component';
import { MultiSelectContentComponent } from './multi-select-content/multi-select-content.component';
import { SingleSelectItemComponent } from './single-select-item/single-select-item.component';
import {MuGroupHeaderComponentV2} from './mu-group-header-v2/mu-group-header-v2.component';
import { ToastModule } from 'primeng/toast';
import {RadioButtonListComponent} from './radiobutton-list/radiobutton-list.component';
import { LearningCurveGroupRendererComponent } from './learning-curve-group-renderer/learning-curve-group-renderer.component';
import {ButtonModule} from 'primeng/button';
import { NewHireClassDialogComponent } from '../pages/plan/new-hire/new-hire-class-dialog/new-hire-class-dialog.component';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';

LicenseManager.setLicenseKey('Using_this_AG_Grid_Enterprise_key_( AG-041476 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( NICE Ltd. )_is_granted_a_( Multiple Applications )_Developer_License_for_( 20 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 10 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 14 September 2024 )____[v2]_MTcyNjI2ODQwMDAwMA==2123436a90a7507f00558e03058af4b0');

@NgModule({ declarations: [
        WfmTextboxComponent,
        WfmSelectComponent,
        WfmModalComponent,
        CreatePlanComponent,
        CreatePlanComponentV2,
        RefreshPromptComponent,
        FullWidthTableDirective,
        InputTextComponent,
        BreezeButtonComponent,
        PageTitleComponent,
        CheckboxListComponent,
        WeekPickerComponent,
        TaskProgressComponent,
        EspTableHeaderComponent,
        EspNoRowsOverlayComponent,
        GridItemActionComponent,
        SideNavComponent,
        InputFocusDirective,
        ToastSingleAnnounceDirective,
        DatepickerDayAriaLabelsDirective,
        MultiSelectFilterComponent,
        MultiSelectFooterComponent,
        LoadingRowsOverlayComponent,
        ValidationNavigatorComponent,
        MuGroupHeaderComponent,
        MuGroupHeaderComponentV2,
        ApiCredentialComponent,
        WfmIcontextboxComponent,
        MultiSelectItemComponent,
        MultiSelectContentComponent,
        SingleSelectItemComponent,
        RadioButtonListComponent,
        LearningCurveGroupRendererComponent,
        NewHireClassDialogComponent
    ],
    exports: [
        WfmTextboxComponent,
        WfmSelectComponent,
        WfmModalComponent,
        CreatePlanComponent,
        CreatePlanComponentV2,
        RefreshPromptComponent,
        FullWidthTableDirective,
        InputTextComponent,
        BreezeButtonComponent,
        IconNameDirective,
        PageTitleComponent,
        CheckboxListComponent,
        WeekPickerComponent,
        TaskProgressComponent,
        EspTableHeaderComponent,
        EspNoRowsOverlayComponent,
        GridItemActionComponent,
        SideNavComponent,
        InputFocusDirective,
        ToastSingleAnnounceDirective,
        DatepickerDayAriaLabelsDirective,
        MultiSelectFilterComponent,
        MultiSelectFooterComponent,
        LoadingRowsOverlayComponent,
        ValidationNavigatorComponent,
        ApiCredentialComponent,
        WfmIcontextboxComponent,
        MultiSelectItemComponent,
        MultiSelectContentComponent,
        SingleSelectItemComponent,
        RadioButtonListComponent,
        LearningCurveGroupRendererComponent,
        NewHireClassDialogComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        MultiSelectModule,
        SvgIconsModule,
        NgbDatepickerModule,
        TooltipModule,
        NgbPopoverModule,
        ToggleSwitchModule,
        TranslateModule.forChild(),
        TimePickerModule,
        DateRangePickerModule,
        OverlayModule,
        ToastModule,
        ButtonModule,
        SelectModule,
        InputNumberModule,
        DatePickerModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ComponentModule {

}
